import React from 'react';

const ResetPasswordContext = React.createContext();

export default ResetPasswordContext;
